import { PhotoShootData, PhotoShootImageData, PhotoShootItemType } from 'apis/mips/types';

import { PhotoShootModel } from '../types';

export const getItemImages = (images: PhotoShootImageData[] = [], imageIds: string[]): PhotoShootImageData[] =>
  imageIds.reduce((acc, imageId) => {
    const image = images.find(img => img.id === imageId);

    if (!image) {
      return acc;
    }

    return [...acc, image];
  }, [] as PhotoShootImageData[]);

export const transformPhotoShootToContextModel = (data: PhotoShootData): PhotoShootModel => {
  const items = (data.items || []).reduce(
    (acc, item) => {
      const images = getItemImages(data.images, item.imageIds || []);

      return {
        ...acc,
        [item.itemType]: [
          ...acc[item.itemType],
          {
            id: item.id,
            menuItemId: item.menuItemId,
            name: item.name,
            description: item.description,
            itemType: item.itemType,
            images,
          },
        ],
      };
    },
    {
      [PhotoShootItemType.MENU_ITEM]: [],
      [PhotoShootItemType.HEADER]: [],
      [PhotoShootItemType.LIST]: [],
    } as PhotoShootModel['items'],
  );

  return {
    ...data,
    images: data.images || [],
    items,
  };
};
